/** WhatsApp deep links need a bare international number. */
export function whatsappLink(number: string, message?: string): string {
  const digits = number.replace(/[^\d]/g, "");
  const query = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${digits}${query}`;
}
